import React from 'react';
import Styles from './FormUsage.css';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { Controller } from 'react-hook-form';
import Select from '../../widgets/Select/Select';
import { combineFieldProps } from '../../shared/utils/form';
import TextField, { MoneyTextFieldEmptyValue } from '../../widgets/TextField/TextField';
import Button from '../../widgets/Button/Button';
import { useScroll } from '../../../../utils/useLayout';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import clsx from 'clsx';
import RangeSelect from '../../widgets/RangeSelect/RangeSelect';
import throttle from 'lodash/throttle';
import { maskMoney, unmaskNumber } from '../../shared/utils/masks';

function FormUsage({ formUsage }) {
  const { scrollToTop } = useScroll();
  const { setSimulationStep, simulationStep, isMobile } = useSimuladorEnergiaSolarState();

  const handleRangeChange = throttle((value = 0) => {
    formUsage.form.setValue('averageUsage', maskMoney(value).replace('R$', '').trim(), {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
  }, 50);

  if (simulationStep?.id !== SIMULATION_STEPS.FORM_USAGE.id) {
    return null;
  }

  return (
    <>
      <div
        id="form-usage"
        className={clsx({
          usage: true,
          hidden: simulationStep?.id !== SIMULATION_STEPS.FORM_USAGE.id,
        })}
      >
        <ContainerHome24>
          <h2 className="usage-title">Qual sua média de gasto com energia elétrica por mês?</h2>
          <p className="usage-subtitle">Selecione ou informe sua média de gasto</p>

          <form className="form-render" onSubmit={formUsage.handleSubmit}>
            {formUsage.fields.map((field) => {
              return (
                <Controller
                  key={`field-${field.name}`}
                  name={field.name}
                  control={formUsage.form.control}
                  render={(renderOptions) => {
                    const isSelect = field.type === 'select';
                    const fieldProps = combineFieldProps(field, renderOptions);

                    return (
                      <div className={'field-wrapper'}>
                        {isSelect && (
                          <Select
                            {...fieldProps}
                            handleValueChange={(v) => {
                              formUsage.form.setValue(field.name, v, true);
                            }}
                          />
                        )}

                        {!isSelect && <TextField {...fieldProps} />}
                      </div>
                    );
                  }}
                />
              );
            })}
          </form>

          {!isMobile && (
            <RangeSelect
              min={200}
              minLabel="R$ 200,00"
              max={20_000}
              maxLabel="R$ 20.000,00"
              value={Number(unmaskNumber(formUsage.currentAverageUsage)) / 100}
              onChange={(v) => {
                handleRangeChange(v * 100);
              }}
            />
          )}

          {!formUsage.form?.formState?.errors?.averageUsage?.message &&
            !!formUsage.currentAverageUsage &&
            formUsage.currentAverageUsage !== MoneyTextFieldEmptyValue && (
              <div className="cost-info">
                <img src="assets/simulador-energia-solar/jornada/ic-usage.svg" alt="" />
                <div>
                  <p>Gasto com energia mensal de:</p>
                  <b>R$ {formUsage.currentAverageUsage}</b>
                </div>
              </div>
            )}

          <div className="button-row-form">
            <Button
              disabled={formUsage.loading}
              variant="white"
              onClick={(ev) => {
                ev.preventDefault();
                scrollToTop();

                setSimulationStep(SIMULATION_STEPS.FORM_BASIC_INFO);
              }}
            >
              Voltar
            </Button>
            <Button
              disabled={formUsage.loading}
              loading={formUsage.loading}
              variant="red"
              type="submit"
              onClick={(ev) => {
                formUsage.handleSubmit(ev);
              }}
            >
              Continuar
            </Button>
          </div>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </>
  );
}

export default FormUsage;
